<template>
    <form autocomplete="off">
        <div class="form-fields">
            <div class="input-line">
                <label for="first-name">First Name <span class="required">*</span></label>
                <input type="text" id="first-name" name="first_name" v-model="form_data.first_name" placeholder="Input Text" @blur="validation.first_name.$touch()" autocomplete="off" />
                <!-- <div class="form-message animated" v-if="validation.first_name.$error">
                    <span class="validate-msg">{{ validation.first_name.$errors[0].$message }}</span>
                </div> -->
                <svg v-if="validation.first_name.$error" class="form-sign animated fadeInRight close" viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
                <svg v-else-if="form_data.first_name" class="form-sign animated fadeInRight check" viewBox="0 0 24 24"><use :xlink:href="spriteHref('check')"></use></svg>
            </div>
            <div class="input-line">
                <label for="last-name">Last Name <span class="required">*</span></label>
                <input type="text" id="last-name" name="last_name" v-model="form_data.last_name" placeholder="Input Text" @blur="validation.last_name.$touch()" autocomplete="off" />
                <!-- <div class="form-message animated" v-if="validation.last_name.$error">
                    <span class="validate-msg">{{ validation.last_name.$errors[0].$message }}</span>
                </div> -->
                <svg v-if="validation.last_name.$error" class="form-sign animated fadeInRight close" viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
                <svg v-else-if="form_data.first_name" class="form-sign animated fadeInRight check" viewBox="0 0 24 24"><use :xlink:href="spriteHref('check')"></use></svg>
            </div>
            <div class="input-line" key="register2" style="--i: 1">
                <label for="company">Company <span class="required">*</span></label>
                <input type="text" name="company" id="company" v-model="form_data.company" placeholder="Company" autocomplete="off" @blur="validation.company.$touch()" />
                <!-- <div class="form-message animated" v-if="validation.company.$error">
                    <span class="validate-msg">{{ validation.company.$errors[0].$message }}</span>
                </div> -->
                <svg v-if="validation.company.$error" class="form-sign animated fadeInRight close" viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
                <svg v-else-if="form_data.company" class="form-sign animated fadeInRight check" viewBox="0 0 24 24"><use :xlink:href="spriteHref('check')"></use></svg>
            </div>
            <div class="width-100percent input-line" key="register1" style="--i: 1">
                <label for="company">Country <span class="required">*</span></label>
                <vue-select v-model="selectedCountry" @update:modelValue="selectUpdate" :options="support_countries" label-by="name" :close-on-select="true" :clear-on-select="true" :searchable="true" :placeholder="'Country'" @blur="validation.country.$touch()">
                    <template #label="{ selected }">
                        <template v-if="selected">
                            <div>
                                <CountryFlag :country="selected.flag2" size="small" />
                                {{ selected.name }}
                            </div>
                        </template>
                    </template>
                    <template #dropdown-item="{ option }">
                        <div>
                            <CountryFlag :country="option.flag2" />
                            {{ option.name }}
                        </div>
                    </template>
                </vue-select>
                
                <!-- <div class="form-message animated" v-if="validation.country.$error">
                    <span class="validate-msg">
                        {{ validation.country.$errors[0].$message }}
                    </span>
                </div> -->
                <svg v-if="validation.country.$error" class="form-sign animated fadeInRight close" viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
                <svg v-else-if="form_data.country" class="form-sign animated fadeInRight check" viewBox="0 0 24 24"><use :xlink:href="spriteHref('check')"></use></svg>
            </div>
            <div class="input-line">
                <label for="email">Email <span class="required">*</span></label>
                <input type="email" id="email" name="email" v-model="form_data.email" placeholder="Input Text" @blur="validation.email.$touch()" autocomplete="email" />
                <!-- <div class="form-message animated" v-if="validation.email.$error">
                    <span class="validate-msg">{{ validation.email.$errors[0].$message }}</span>
                </div> -->
                <svg v-if="validation.email.$error" class="form-sign animated fadeInRight close" viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
                <svg v-else-if="form_data.email" class="form-sign animated fadeInRight check" viewBox="0 0 24 24"><use :xlink:href="spriteHref('check')"></use></svg>
            </div>
            
            <div class="input-line" key="register5" style="--i: 2">
                <label for="password">Password <span class="required">*</span></label>
                <input type="password" name="password" id="password" v-model="form_data.password" placeholder="Input Text" @blur="validation.password.$touch()" autocomplete="new-password" />
                <!-- <div class="form-message animated" v-if="validation.password.$error">
                    <span class="validate-msg">
                        {{ validation.password.$errors[0].$message }}
                    </span>
                </div> -->
                <svg v-if="validation.password.$error" class="form-sign animated fadeInRight close" viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
                <svg v-else-if="form_data.password" class="form-sign animated fadeInRight check" viewBox="0 0 24 24"><use :xlink:href="spriteHref('check')"></use></svg>
            </div>
            
            <div class="input-line"></div>
            <div class="input-line" key="register3" style="--i: 3">
                <label for="confirm_password">Confirm Password <span class="required">*</span></label>
                <input type="password" name="confirm_password" id="confirm_password" v-model="form_data.confirm_password" placeholder="Input Text" @blur="validation.confirm_password.$touch()" autocomplete="new-password-complete" />
                <!-- <div class="form-message animated" v-if="validation.confirm_password.$error">
                    <span class="validate-msg">{{ validation.confirm_password.$errors[0].$message }}</span>
                </div> -->
                <svg v-if="validation.confirm_password.$error" class="form-sign animated fadeInRight close" viewBox="0 0 24 24"><use :xlink:href="spriteHref('close')"></use></svg>
                <svg v-else-if="form_data.confirm_password" class="form-sign animated fadeInRight check" viewBox="0 0 24 24"><use :xlink:href="spriteHref('check')"></use></svg>
            </div>
        </div>
        <Transition name="fade">
            <div class="t-align-c margin-bottom-40 red-color" v-if="errorMessage" v-html="errorMessage"></div>
        </Transition>
        <div class="submitBtnWrapper">
            <button @click.prevent="submitForm" type="submit" class="submit" :disabled="loading">{{ loading ? 'Submitting...' : 'Create Account' }}<svg v-if="!loading" viewBox="0 0 20 20"><use :xlink:href="spriteHref('arrow_right')"></use></svg></button>
            <div class="logn-info">Already registered? Go to the <a :href="HOME_URL+'login'">login page</a>.</div>
        </div>
        
    </form>
</template>

<script>
import { ref, reactive, computed, toHandlers ,watch} from "vue";
import { HOME_URL,WEB_USERNAME,WEB_PASS,ENV } from "../constants/envrionment";
import { support_countries } from "../config/config";
import useValidate from "@vuelidate/core";
import {
    required,
    minLength,
    email,
    sameAs,
    helpers,
    maxLength,
} from "@vuelidate/validators";
import VueNextSelect from "vue-next-select";
import 'vue-next-select/dist/index.css'
import CountryFlag from "vue-country-flag-next";
import { useReCaptcha } from 'vue-recaptcha-v3'

export default {
    components: {
        "vue-select": VueNextSelect,
        CountryFlag,
    },
    
    setup(props) {
        const form_data = reactive({
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            confirm_password: "",
            country: "",
            company: "",
            recaptcha_token : "",
        });
        
        const rules = computed(() => {
            return {
                first_name: {
                    required: helpers.withMessage("The first name is required", required),
                },
                last_name: {
                    required: helpers.withMessage("The last name is required", required),
                },
                email: {
                    required: helpers.withMessage("The e-mail is required", required),
                    email: helpers.withMessage("Not a valid email address",email),
                },
                password: {
                    required: helpers.withMessage("Password is required", required),
                    minLength: helpers.withMessage("The length must be minimum 12 characters",minLength(12)),
                    maxLength: helpers.withMessage("The length must be maximum 64 characters",maxLength(64)),
                },
                confirm_password: {
                    required: helpers.withMessage("Please confirm your password",required),
                    minLength: helpers.withMessage("The length must be minimum 12 characters",minLength(12)),
                    maxLength: helpers.withMessage("The length must be maximum 64 characters",maxLength(64)),
                    sameAs: helpers.withMessage("Passwords don't match",sameAs(form_data.password)),
                },
                country: {
                    required: helpers.withMessage("The country is required", required),
                },
                company: {
                    required: helpers.withMessage("Company is required", required),
                },
            };
        });
        
        const validation = useValidate(rules, form_data);
        const selectedCountry = reactive({});
        let recaptcha = useReCaptcha();

        return {
            selectedCountry,
            form_data,
            validation,
            support_countries,
            HOME_URL,
            recaptcha,
            loading: ref(false),
            errorMessage: ref(""),
        };
    },
    methods: {
        async generateRecaptchaToken () {
            // (optional) Wait until recaptcha has been loaded.

            const { executeRecaptcha, recaptchaLoaded } = this.recaptcha

            await recaptchaLoaded()
            
            let recaptcha_token = await executeRecaptcha('generate');

            this.form_data['recaptcha_token'] = recaptcha_token

        },
        selectUpdate(selectedCountry) {
            this.form_data.country = selectedCountry.flag2;
        },
        async submitForm() {

            if (this.loading) return;

            let self = this;
            const validateStatus = await this.validation.$validate()

            if (validateStatus) {
            
                this.loading = true;

                await self.generateRecaptchaToken()

                // POST request using fetch with error handling
                var requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(self.form_data)
                };

                if(ENV == 'dev'){
                    requestOptions['headers']['authorization'] = "Basic " + btoa(WEB_USERNAME + ":" + WEB_PASS)
                }

                fetch(self.HOME_URL+'users/account/sign_up', requestOptions)
                .then(async response => {

                    const data = await response.json();

                    // check for error response
                    if (data.status) {
                        window.location.href= HOME_URL+'thank-you?ref_ga=only_account';
                    }
                    else{
                        self.errorMessage = data.message
                        self.loading = false;
                    }
                    
                    self.postId = data.id;

                })
                .catch(error => {
                    self.errorMessage = error.message
                    console.error('There was an error!', error);
                    self.loading = false;
                })
            }
        }
    },
    mounted: function () {

        let self = this;

        this.HOME_URL = HOME_URL
        this.support_countries = support_countries
    }
};
</script>